import React, { Component } from "react";

import HeadersAuth from "../Layouts/HeadersAuth";
import axios from "axios";
import $ from "jquery";
import { useHistory } from "react-router-dom";

export class RegisterChief extends Component {
  constructor(props) {
    super(props);

   

    this.state = {
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      password: "",
      tel: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    // const url = ''
    const headers = {
      "Content-Type": "application/json",
      chiefparams: "abcd",
    };
    event.preventDefault();
    // console.log(this.state)
    if (this.state.password !== this.state.password2) {
      $("#passwordError").fadeIn();
    } else {
      $("#passwordError").fadeOut();
      console.log(this.state);
      this.setState({ loading: true });
      console.log(this.api_url+"staff/register");
      // +
      axios
        .post(this.api_url+"staff/register", this.state, {
          headers: headers,
        })
        .then((response) => {
          console.log(response.data);
          this.setState({ loading: false });
          if (response.data["token"]) {
            $("#submitSuccess").fadeIn();
            localStorage.setItem("accessToken", response.data["token"]);

            setTimeout(function (props) {
              window.location.href = "/confirm/staff/member";
              // this.props.history.push('/reception/dashboard')
            }, 2000);
            // this.props.history.push('/reception/dashboard')
          } else {
            $("#submitError").fadeIn();
          }
        })
        .catch((error) => {
          $("#submitError").fadeIn();
          this.setState({ loading: false });
          console.log(error);
        });
    }
  };

  componentDidMount() {
    this.setState({
      specialty_description: "Default",
    });

    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const { first_name, last_name, username, email, tel, password, password2 } =
      this.state;
    const loading = this.state.loading;
    // const displayHidden = { display: "none" };
    return (
      <div>
        <HeadersAuth />

        <main>
          <div className="container p-5">
            <form onSubmit={this.handleSubmit} enctype="multipart/form-data">
              <div className="form-row center">
                <h4 className="text-capitalize">Basic Details</h4>
              </div>
              <div className="form-row pt-2">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      First Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={first_name}
                      name="first_name"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Last Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={last_name}
                      name="last_name"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Username
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={username}
                      name="username"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2"></div>
              </div>
              <div className="form-row center mt-5">
                <h4 className="text-capitalize">Contact Information</h4>
              </div>
              <div className="form-row pb-4 pt-2">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Phone Number
                    </h6>
                    <input
                      name="tel"
                      onChange={this.handleChange}
                      value={tel}
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Email Address</h6>
                    <input
                      name="email"
                      className="form-control"
                      onChange={this.handleChange}
                      value={email}
                      type="email"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Password
                    </h6>
                    <input
                      name="password"
                      className="form-control"
                      onChange={this.handleChange}
                      value={password}
                      type="password"
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Confirm Password
                    </h6>
                    <input
                      name="password2"
                      className="form-control"
                      onChange={this.handleChange}
                      value={password2}
                      type="password"
                    />
                  </div>
                </div>
              </div>

              <center>
                <div className="row">
                  {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                  <div
                    className="alert alert-danger"
                    id="submitError"
                    style={displayHidden}
                    role="alert"
                  >
                    <strong>Wait </strong>Something went wrong. Please check
                    your form and try again
                  </div>
                  <div
                    className="alert alert-danger"
                    id="passwordError"
                    style={displayHidden}
                    role="alert"
                  >
                    <strong>Wait </strong>Passwords don't match
                  </div>
                  <div
                    id="submitSuccess"
                    className="alert alert-success"
                    style={displayHidden}
                    role="alert"
                  >
                    <strong>Success! </strong>Logging you in.
                  </div>
                  <div className="col col-6">
                    <button
                      className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                      type="submit"
                      style={floatLeft}
                    >
                      {loading ? <span>Loading...</span> : <span>Submit</span>}
                    </button>
                  </div>
                </div>
              </center>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default RegisterChief;
